// extracted by mini-css-extract-plugin
export default {"modify_order_header":"Uv","center":"Vv","empty":"Wv","pending":"Xv","referralTitle":"Yv","wrapper":"Zv","title":"aw","tabs":"bw","tab":"cw","active":"ew","btn":"fw","rewards_table":"gw"};
    if(module.hot) {
      // 1714442369085
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  